module.exports = __webpack_public_path__ + "img/zhifubao.fbdbbcc6.png";